import type { FormaPagamento, PixTipoChave, SolicitacaoPagamentoFormValues } from "@/services/solicitacaoPagamento";

export const PIX_TIPO_CHAVE_OPTIONS: Array<{ value: PixTipoChave; label: string }> = [
  { value: "CELULAR", label: "Celular" },
  { value: "CPF_CNPJ", label: "CPF/CNPJ" },
  { value: "EMAIL", label: "E-mail" },
  { value: "ALEATORIA", label: "Chave aleatória" },
];

export function pixTipoChaveLabel(value: string): string {
  return PIX_TIPO_CHAVE_OPTIONS.find((o) => o.value === value)?.label ?? value;
}

export function clearDadosPagamentoForForma(
  _forma: FormaPagamento | "",
): Partial<SolicitacaoPagamentoFormValues> {
  return {
    boletoCodigoBarras: "",
    pixTipoChave: "",
    pixChave: "",
    pixContaEmNome: "",
    transferenciaTitular: "",
    transferenciaBanco: "",
    transferenciaAgencia: "",
    transferenciaConta: "",
  };
}

export function validateDadosPagamento(
  values: SolicitacaoPagamentoFormValues,
): Record<string, string> {
  const errors: Record<string, string> = {};
  if (values.formaPagamento === "BOLETO") {
    if (!values.boletoCodigoBarras.trim()) {
      errors.boletoCodigoBarras = "Informe o código de barras.";
    }
  }
  if (values.formaPagamento === "PIX") {
    if (!values.pixTipoChave) errors.pixTipoChave = "Selecione o tipo de chave.";
    if (!values.pixChave.trim()) errors.pixChave = "Informe a chave Pix.";
    if (!values.pixContaEmNome.trim()) errors.pixContaEmNome = "Informe a conta em nome.";
  }
  if (values.formaPagamento === "TRANSFERENCIA") {
    if (!values.transferenciaTitular.trim()) errors.transferenciaTitular = "Informe o titular.";
    if (!values.transferenciaBanco.trim()) errors.transferenciaBanco = "Informe o banco.";
    if (!values.transferenciaAgencia.trim()) errors.transferenciaAgencia = "Informe a agência.";
    if (!values.transferenciaConta.trim()) errors.transferenciaConta = "Informe a conta.";
  }
  return errors;
}
